import React from 'react';

export type SortDirection = 'asc' | 'desc';

export interface SortableTableHeaderProps<T extends string> {
    label: string;
    sortKey: T;
    currentSortBy: T;
    sortDirection: SortDirection;
    onSort: (sortKey: T) => void;
    rowSpan?: number;
    colSpan?: number;
    className?: string;
}

export const sortIcons = {
    sorted: {
        asc: '▲',
        desc: '▼',
    },
    unsorted: '▲▼',
};

export const SortableTableHeader = <T extends string>({ 
    label,
    sortKey,
    currentSortBy,
    sortDirection,
    onSort,
    rowSpan,
    colSpan,
    className = ''
}: SortableTableHeaderProps<T>) => (
    <th
        role="button"
        onClick={() => onSort(sortKey)}
        className={`text-center text-nowrap ${className}`}
        style={{ cursor: 'pointer' }}
        rowSpan={rowSpan}
        colSpan={colSpan}
    >
        {label} {currentSortBy === sortKey
        ? (sortDirection === 'desc' ? sortIcons.sorted.desc : sortIcons.sorted.asc)
        : sortIcons.unsorted}
    </th>
);
